import { UtilizationRange } from './utilization-range';

export class TimeWindow {
  public utilizationRanges: Array<UtilizationRange> | undefined;
  public startTime: Date | undefined;
  public endTime: Date | undefined;
  public timeWindowDescription: string | undefined;
}
